/**
 * Single source of truth for product/brand strings on the web app.
 *
 * Reads `VITE_APP_NAME` from the build-time env so a deployment can
 * relabel without touching code. The default ('Bacsys Atom') matches
 * the full mobile app's brand so all three surfaces are aligned by
 * default; override in `.env.production` for a different deployment.
 */
export const APP_NAME = (import.meta.env.VITE_APP_NAME as string | undefined)
  ?.trim() || 'Bacsys Optimo'

/** Path to the brand mark SVG (served from `public/`). */
export const APP_LOGO = '/logo.svg'
